import { combineReducers } from "redux";
import {
  companiesReducer,
  customersReducer,
  passiveCustomerReducer,
  myUserDetailReducer,
  projectDetailReducer,
  insourcePersonalReducer,
  filterSectionProjectInfoReducer,
  projectClosingReportReducer,
  allPersonnelReducer,
  languageListReducer,
  languageLevelListReducer,
  personalCommunicationLevelListReducer,
  countryListReducer,
  cityListReducer,
  townListReducer,
  collageListReducer,
  departmentListReducer,
  graduationStatusListReducer,
  militaryServiceStatusListReducer,
  driversLicenseListReducer,
  technicListReducer,
  personalAbilityListReducer,
  communicationParameterListReducer,
  allMemberListForPositionReducer,
  customerListReducer,
  technicGroupMainListReducer,
  technicalReducer,
  positionListReducer,
  positionListByCompanyReducer,
  positionListByTechnicGroupReducer,
  positionListByProjectReducer,
  navCandidateSearchReducer,
  versionsReducer,
} from "./memberList";
import { projectDetailWithEmployeesReducer } from "./memberReducer";
import uiReducer from "../slices/ui";

const rootReducer = combineReducers({
  ui: uiReducer,
  companies: companiesReducer,
  customerList: customersReducer,
      customers: customerListReducer,
  passiveCustomerList: passiveCustomerReducer,
  myUserDetail: myUserDetailReducer,
  projectDetail: projectDetailReducer,
  projectDetailWithEmployees: projectDetailWithEmployeesReducer,
  insourcePersonal: insourcePersonalReducer,
  filterSectionProjectInfo: filterSectionProjectInfoReducer,
  projectClosingReport: projectClosingReportReducer,
  allPersonnel: allPersonnelReducer,
  allMemberListForPosition: allMemberListForPositionReducer,
  // Uygulamanin gercek store'u index.tsx -> configureStore.tsx -> bu dosya.
  // Kayit yalnizca redux/store.ts'e yapilinca state.languageList undefined kaliyor ve
  // useFieldOptions'taki destructuring Aday Aktarma sihirbazini tumuyle cokertiyordu.
  languageList: languageListReducer,
  languageLevelList: languageLevelListReducer,
  personalCommunicationLevelList: personalCommunicationLevelListReducer,
  countryList: countryListReducer,
  cityList: cityListReducer,
  townList: townListReducer,
  collageList: collageListReducer,
  departmentList: departmentListReducer,
  graduationStatusList: graduationStatusListReducer,
  militaryServiceStatusList: militaryServiceStatusListReducer,
  driversLicenseList: driversLicenseListReducer,
  technicList: technicListReducer,
  personalAbilityList: personalAbilityListReducer,
  communicationParameterList: communicationParameterListReducer,
  technicGroupMainList: technicGroupMainListReducer,
  technicalList: technicalReducer,
  positionList: positionListReducer,
  positionListByCompany: positionListByCompanyReducer,
  positionListByTechnicGroup: positionListByTechnicGroupReducer,
  positionListByProject: positionListByProjectReducer,
  navCandidateSearch: navCandidateSearchReducer,
  versions: versionsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
